import { LoginPage } from './containers'

export { LoginPage }



// WEBPACK FOOTER //
// ./client/Modules/LoginPage/index.js